const APIs = {
  LOGIN: `api/Auth/LoginSuperPanel`,

  // Auto-Login APIs
  GENERATE_AUTO_LOGIN_TOKEN: `/api/Auth/GenerateAutoLoginToken`,
  AUTO_LOGIN: `/api/Auth/AutoLogin`,

  // Dashboard
  GET_DASHBOARD_STATS: `/api/Dashboard/GetDashboardStats`,

   //Company
   GET_COMPANY: `/api/Company/UpdatedCompanyData`,
   Get_COMPANY_BY_ID: `/api/Company/GetCompanyByID`,
   GET_ALL_COMPANIES: `/api/Company/GetCompaniesList`,
   GET_COMPANY_PROFILE:   `/api/Company/Profile`,
   POST_ADD_COMPANY: `/api/Company/AddCompany`,
   POST_UPDATE_COMPANY: `/api/Company/UpdateSuperCompany`,
   PUT_UPDATE_COMPANY_DATA: `/api/Company/UpdateSuperCompany`,
   POST_UPDATE_COMPANY_DATA: `/api/Company/UpdateCompany`,
   POST_UPDATE_WEEKLY_SERVICE_HOURS: `/api/Company/UpdateCompanyServiceHours`,
   GET_COMPANY_SETTINGS : `/api/Setting/GetCompanySettings`,
   POST_UPDATE_COMPANY_SETTING:`/api/Setting/UpdateCompanySettings`,
   DELETE_COMPANY: `/api/Company/DeleteCompany`,

  // Twilio Platform (ServeIQ-managed keys)
  GET_TWILIO_PLATFORM_CONFIG: `/api/TwilioPlatformConfig/SA_GetTwilioPlatformConfig`,
  SAVE_TWILIO_PLATFORM_CONFIG: `/api/TwilioPlatformConfig/SA_SaveTwilioPlatformConfig`,

  // Payment Gateway Platforms (global catalog — restaurant gateways)
  SA_GET_ALL_PAYMENT_GATEWAY_PLATFORMS: `/api/PaymentGatewayPlatform/SA_GetAllPaymentGatewayPlatforms`,
  SA_GET_PAYMENT_GATEWAY_PLATFORM_BY_ID: `/api/PaymentGatewayPlatform/SA_GetPaymentGatewayPlatformByID`,
  SA_ADD_UPDATE_PAYMENT_GATEWAY_PLATFORM: `/api/PaymentGatewayPlatform/SA_AddUpdatePaymentGatewayPlatform`,
  SA_DELETE_PAYMENT_GATEWAY_PLATFORM: `/api/PaymentGatewayPlatform/SA_DeletePaymentGatewayPlatform`,
  SA_UPDATE_PAYMENT_GATEWAY_PLATFORM_STATUS: `/api/PaymentGatewayPlatform/SA_UpdatePaymentGatewayPlatformStatus`,

  // Subscription Dojo (SaaS invoice billing — separate from restaurant platforms)
  SA_GET_SUBSCRIPTION_DOJO_CONFIG: `/api/SubscriptionDojoConfig/SA_GetSubscriptionDojoConfig`,
  SA_SAVE_SUBSCRIPTION_DOJO_CONFIG: `/api/SubscriptionDojoConfig/SA_SaveSubscriptionDojoConfig`,

  // Company email sender (AWS SES)
  SA_GET_COMPANY_EMAIL_SETTINGS: `/api/CompanyEmailSettings/SA_GetCompanyEmailSettings`,
  SA_MARK_COMPANY_EMAIL_SETTINGS_VERIFIED: `/api/CompanyEmailSettings/SA_MarkCompanyEmailSettingsVerified`,
  SA_GET_COMPANY_EMAIL_SETTINGS_LIST: `/api/CompanyEmailSettings/SA_GetCompanyEmailSettingsList`,

  // Devices

   GET_ALL_DEVICES_OF_COMPANY : `/api/Till/BO_GetCompanyDevices`,
   PATCH_UPDATE_DEVICE_STATUS : `/api/Till/UpdateCompanyStatus`,
   DELETE_COMPANY_TILL: `/api/Till/DeleteCompanyTill`,
   GET_COMPANY_DEVICES: `/api/Device/GetCompanyDevices`,
   ADD_COMPANY_DEVICE: `/api/Device/AddCompanyDevice`,
   UPDATE_COMPANY_DEVICE: `/api/Device/UpdateCompanyDevice`,
   DELETE_COMPANY_DEVICE: `/api/Device/DeleteCompanyDevice`,

   // Payment Gateways

  GET_ALL_PAYMENT_GATEWAYS:`/api/PaymentGateway/BO_GetPaymentGateways`,
  POST_ADD_PAYMENT_GATEWAY: `/api/PaymentGateway/AddPaymentGateway`,
  UPDATE_PAYMENT_GATEWAY: `/api/PaymentGateway/UpdatePaymentGateway`,
  DELETE_PAYMENT_GATEWAY: `/api/PaymentGateway/DeletePaymentGateway`,

  // Payment Providers

  GET_ALL_PAYMENT_PROVIDERS: `/api/PaymentProvider/GetAllPaymentProviders`,
  GET_PAYMENT_PROVIDER_BY_ID: `/api/PaymentProvider/GetPaymentProviderByID`,
  POST_ADD_UPDATE_PAYMENT_PROVIDER: `/api/PaymentProvider/AddUpdatePaymentProvider`,
  DELETE_PAYMENT_PROVIDER: `/api/PaymentProvider/DeletePaymentProvider`,
  PATCH_UPDATE_PAYMENT_PROVIDER_STATUS: `/api/PaymentProvider/UpdatePaymentProviderStatus`,
  POST_UPDATE_PAYMENT_PROVIDER_SORT_ORDER: `/api/PaymentProvider/UpdatePaymentProviderSortOrder`,

  // Allergens APIs (SuperAdmin - No CompID restrictions)
  GET_ALL_ALLERGENS: `/api/Allergen/SuperAdmin/GetAllAllergens`,
  GET_ALLERGEN_BY_ID: `/api/Allergen/SuperAdmin/GetAllergenByID`,
  POST_INSERT_ALLERGEN: `/api/Allergen/SuperAdmin/InsertAllergen`,
  PUT_UPDATE_ALLERGEN: `/api/Allergen/SuperAdmin/UpdateAllergen`,
  DELETE_ALLERGEN: `/api/Allergen/SuperAdmin/DeleteAllergen`,
  POST_UPDATE_ALLERGEN_SORT_ORDER: `/api/Allergen/SuperAdmin/UpdateAllergenSortOrder`,

   // Staff
   GET_COMPANY_STAFF: `/api/Staff/BO_GetCompanyStaff`,
   DELETE_COMPANY_STAFF: `/api/Staff/DeleteStaff`,
   GET_STAFF_DATA: `/api/Staff/GetUserByUserName`,
   ADD_STAFF: `/api/Staff/AddUser`,
   UPDATE_STAFF: `/api/Staff/UpdateUser`,
   UPDATE_PASSWORD: `/api/Staff/UpdatePassword`,
   ADD_COMPANY_STAFF: `/api/Staff/AddCompanyStaff`,
   UPDATE_COMPANY_STAFF: `/api/Staff/UpdateCompanyStaff`,


  //Roles
  GET_ROLES: `/api/RolePermission/GetAllRoles`,
  GET_ROLE_BY_ID: `/api/RolePermission/GetRoleByID`,
  ADD_ROLE: `/api/RolePermission/AddNewRole`,
  UPDATE_ROLE: `/api/RolePermission/UpdateRolePermission`,
  DELETE_ROLE: `/api/RolePermission/DeleteRole`,


  // Countries
  GET_COUNTRIES: `/api/Country/GetAllCountries`,

  //City

  GET_ALL_CITIES: `/api/City/GetAllCitiesListForCountryCode`,

  // Categories
  GET_CATEGORIES: `/api/RootCategories/BO_GetAllCategories`,
  GET_CATEGORY_ROOT_ID: `/api/RootCategories/GetRootCategoryByRootCatID`,
  ADD_CATEGORY: `/api/RootCategories/AddCategory`,
  UPDATE_CATEGORY: `/api/RootCategories/UpdateCategory`,
  POST_UPDATE_CATEGORY_SORT_ORDER: `/api/RootCategories/UpdateCategorySortOrder`,
  POST_UPDATE_CATEGORY_STATUS: `/api/RootCategories/UpdateCategoryStatus`,
  DELETE_ROOT_CATEGORY: `/api/RootCategories/DeleteCategory`,

  // Menus

  POST_ADD_MENU: `/api/Menu/AddMenu`,
  POST_ADD_MENU_GROUP_LIST: `/api/MenuGroup/AddMenuGroupList`,
  GET_MENU_LIST: `/api/Menu/BO_GetAllMenus`,
  GET_MENU_BY_MENU_ID: `/api/Menu/GetMenuByMenuID`,
  GET_All_MENU_GroupS: `/api/Menu/GetAllMenusWithTheirGroups`,
  DELETE_MENU: `/api/Menu/DeleteMenu`,
  PUT_UPDATE_MENU_AND_MENU_GROUP: `/api/Menu/UpdateMenu`,
  POST_UPDATE_MENU_SORT_ORDER: `/api/Menu/UpdateMenuSortOrder`,
  POST_UPDATE_MENU_STATUS: `/api/Menu/UpdateMenuStatus`,


  //  Item
  POST_CREATE_MENU_ITEM: `/api/Item/AddMenuItem`,
  GET_ALL_ITEMS_FOR_GRID: `/api/Item/BO_GetAllItems`,
  GET_ALL_PRODUCTS: `/api/Item/GetAllMenuItems`,
  GET_ALL_ONLY_PRODUCTS: `/api/Item/GetAllOnlyMenuItems`,
  POST_UPLOAD_PRODUCT_IMAGE: `/api/Item/UploadMenuItemImage`,
  GET_ITEM_BY_ID: `/api/Item/GetMenuItemByID`,
  PUT_UPDATE_ITEM: `/api/Item/UpdateMenuItem`,
  DELETE_ITEM: `/api/Item/DeleteMenuItem`,
  POST_UPDATE_ITEM_SORT_ORDER: `/api/Item/UpdateMenuItemSortOrder`,
  POST_UPDATE_ITEM_STATUS: `/api/Item/UpdateMenuItemStatus`,
  GET_ALL_SHORTED_PRODUCTS: `/api/Item/GetMenuItemsWithShortDetail`,


  // Modifiers
  GET_SEARCH_MODIFIERS: `/api/Modifier/BO_SearchModifier`,


  // Modifier Group

  POST_ADD_MODIFIER_GROUP: `/api/ModifierGroup/AddModifierGroup`,
  GET_ALL_MODIFIER_GROUPS: `/api/ModifierGroup/BO_GetAllModifierGroups`,
  DELETE_MODIFIER_GROUP: `/api/ModifierGroup/DeleteModifierGroup`,
  POST_CHANGE_SKIP_ABLE: `/api/ModifierGroup/ChangeModifierSKipAble`,
  GET_MODIFIER_GROUP_BY_ID: `/api/ModifierGroup/GetModifierGroupByID`,
  PUT_UPDATE_MODIFIER_GROUP: `/api/ModifierGroup/UpdateModifierGroup`,



  //Discount
  GET_ALL_DISCOUNTS: `/api/Discount/BO_GetCompanyDiscountEntry`,
  GET_DISCOUNT_BY_ID: `/api/Discount/GetDiscountByID`,
  POST_ADD_DISCOUNT: `/api/Discount/InsertDiscountEntry`,
  PUT_UPDATE_DISCOUNT: `/api/Discount/UpdateDiscountEntry`,
  DELETE_DISCOUNT: `/api/Discount/DeleteDiscountEntry`,



  //Orders
  GET_ALL_ORDERS: `/api/RecvOrder/BO_GetOrders`,
  DELETE_ORDER: `/api/RecvOrder/ArchieveRecvOrder`,


  //Service Time
  GET_ALL_SERVICE_TIME: `/api/ServiceTime/GetAllServiceTimes`,
  GET_SERVICE_TIME_BY_ID: `/api/ServiceTime/GetServiceTimeforID`,
  POST_ADD_SERVICE_TIME: `/api/ServiceTime/AddServiceTime`,
  PUT_UPDATE_SERVICE_TIME: `/api/ServiceTime/UpdateServiceTime`,
  DELETE_SERVICE_TIME: `/api/ServiceTime/DeleteServiceTime`,

  //Service Time Details
  GET_SERVICE_TIME_DETAILS: `/api/ServiceTimeDetail/GetServiceTimeDetailList`,
  GET_SERVICE_TIME_DETAIL_BY_ID: `/api/ServiceTimeDetail/GetAllServiceTimeDetailsByCompany`,
  POST_ADD_SERVICE_TIME_DETAIL: `/api/ServiceTimeDetail/AddServiceTimeDetail`,



  // Customers
  GET_ALL_CUSTOMERS: `/api/Customer/BO_GetCustomerList`,
  GET_ALL_CUSTOMERS_GROUP_TYPE_LIST: `/api/CustomerTypeGroup/GetAllCustomerTypeGroups`,
  GET_CUSTOMERS_GROUP: `/api/CustomerTypeGroup/BO_GetCustomerTypeGroupList`,
  POST_ADD_UPDATE_CUSTOMER_GROUP: `/api/CustomerTypeGroup/AddUpdateCustomerGroup`,
  DELETE_CUSTOMER_GROUP_TYPE: `/api/CustomerTypeGroup/DeleteCustomerGroup`,
  POST_ADD_CUSTOMER: `/api/Customer/AddCustomer`,
  GET_CUSTOMER_BY_ID: `/api/Customer/GetCustomerByID`,
  PUT_UPDATE_CUSTOMER: `/api/Customer/UpdateCustomer`,
  PATCH_UPDATE_CUSTOMER_EMAIL_ADDRESS: `/api/Customer/UpdateCustomerEmailAddress`,
  DELETE_CUSTOMER_BY_ID: `/api/Customer/DeleteCustomerByID`,


  // Receipt Info
  GET_RECEIPT_INFO: `/api/Receipt/GetReceiptInfo`,
  POST_UPDATE_RECEIPT_INFO: `/api/Receipt/UpdateReceiptInfo`,

  // Currency
  GET_ALL_CURRENCIES: `/api/Shared/GetAllCurrencies`,
  GET_ALL_TIMEZONE: `/api/Shared/GetAllTimeZones`,


  // ==================== SUBSCRIPTION SYSTEM ====================

  // Packages
  GET_ALL_PACKAGES: `/api/Package/GetAllPackages`,
  GET_ALL_PACKAGES_WITH_PRICES: `/api/Package/GetAllPackagesWithPrices`,
  GET_PACKAGE_BY_ID: `/api/Package/GetPackageByID`,
  GET_PACKAGE_WITH_PRICES: `/api/Package/GetPackageWithPrices`,
  POST_ADD_PACKAGE: `/api/Package/AddPackage`,
  PUT_UPDATE_PACKAGE: `/api/Package/UpdatePackage`,
  DELETE_PACKAGE: `/api/Package/DeletePackage`,
  PATCH_UPDATE_PACKAGE_STATUS: `/api/Package/UpdatePackageStatus`,

  // Package Prices
  GET_PACKAGE_PRICES: `/api/Package/GetPackagePrices`,
  POST_ADD_PACKAGE_PRICE: `/api/Package/AddPackagePrice`,
  PUT_UPDATE_PACKAGE_PRICE: `/api/Package/UpdatePackagePrice`,
  DELETE_PACKAGE_PRICE: `/api/Package/DeletePackagePrice`,

  // Subscriptions
  GET_ACTIVE_SUBSCRIPTION: `/api/Subscription/GetActiveSubscription`,
  GET_COMPANY_ACTIVE_SUBSCRIPTION: `/api/Subscription/GetCompanyActiveSubscription`,
  GET_SUBSCRIPTION_BY_ID: `/api/Subscription/GetSubscriptionByID`,
  GET_COMPANY_SUBSCRIPTIONS: `/api/Subscription/GetCompanySubscriptions`,
  GET_EXPIRING_SUBSCRIPTIONS: `/api/Subscription/GetExpiringSubscriptions`,
  POST_CREATE_SUBSCRIPTION: `/api/Subscription/CreateSubscription`,
  POST_ASSIGN_PACKAGE_WITH_INVOICE: `/api/Subscription/AssignPackageWithInvoice`,
  POST_ASSIGN_PACKAGES_WITH_INVOICE: `/api/Subscription/AssignPackagesWithInvoice`,
  PUT_SAVE_PACKAGE_ENTITLEMENTS: `/api/Package/SavePackageEntitlements`,
  PUT_UPDATE_SUBSCRIPTION: `/api/Subscription/UpdateSubscription`,
  POST_CANCEL_SUBSCRIPTION: `/api/Subscription/CancelSubscription`,
  POST_RENEW_SUBSCRIPTION: `/api/Subscription/RenewSubscription`,
  POST_UPDATE_EXPIRED_SUBSCRIPTIONS: `/api/Subscription/UpdateExpiredSubscriptions`,

  // Invoices
  GET_INVOICE_BY_ID: `/api/Invoice/GetInvoiceByID`,
  GET_INVOICE_BY_NUMBER: `/api/Invoice/GetInvoiceByNumber`,
  GET_COMPANY_INVOICES: `/api/Invoice/GetCompanyInvoices`,
  GET_INVOICES_BY_COMPANY_ID: `/api/Invoice/GetInvoicesByCompanyID`,
  GET_ALL_INVOICES: `/api/Invoice/GetAllInvoices`,
  GET_INVOICE_WITH_DETAILS: `/api/Invoice/GetInvoiceByID`,
  POST_CREATE_INVOICE: `/api/Invoice/CreateInvoice`,
  PUT_UPDATE_INVOICE: `/api/Invoice/UpdateInvoice`,
  DELETE_PENDING_INVOICE: `/api/Invoice/DeletePendingInvoice`,
  POST_MARK_INVOICE_AS_PAID: `/api/Invoice/MarkInvoiceAsPaid`,
  POST_APPROVE_INVOICE_REFUND: `/api/Invoice/ApproveInvoiceRefund`,
  GET_INVOICE_ITEMS: `/api/Invoice/GetInvoiceItems`,

  // EPOS / Flutter subscription billing
  EPOS_GET_INVOICE_YEAR_SUMMARY: `/api/Invoice/EPOS_GetInvoiceYearSummary`,
  EPOS_GET_INVOICES_BY_MONTH: `/api/Invoice/EPOS_GetInvoicesByMonth`,
  EPOS_GET_COMPANY_INVOICES: `/api/Invoice/EPOS_GetCompanyInvoices`,
  EPOS_GET_INVOICE_DETAIL: `/api/Invoice/EPOS_GetInvoiceDetail`,
  EPOS_REQUEST_INVOICE_REFUND: `/api/Invoice/EPOS_RequestInvoiceRefund`,

  // SMS package catalog (tbl_SmsPackage)
  GET_SMS_PACKAGES: `/api/SmsPackage/GetAll`,
  GET_SMS_PACKAGE_BY_ID: `/api/SmsPackage/GetByID`,
  POST_ADD_SMS_PACKAGE: `/api/SmsPackage/Add`,
  PUT_UPDATE_SMS_PACKAGE: `/api/SmsPackage/Update`,
  PATCH_UPDATE_SMS_PACKAGE_STATUS: `/api/SmsPackage/UpdateStatus`,

  // EPOS SMS credits / top-up packs
  EPOS_GET_SMS_BALANCE: `/api/Invoice/EPOS_GetSmsBalance`,
  EPOS_GET_SMS_PACKAGES: `/api/SmsPackage/EPOS_GetSmsPackages`,
  EPOS_PURCHASE_SMS_PACKAGE: `/api/SmsPackage/EPOS_PurchaseSmsPackage`,

  // Payments
  GET_TRANSACTION_BY_ID: `/api/Payment/GetTransactionByID`,
  GET_TRANSACTION_BY_REFERENCE: `/api/Payment/GetTransactionByReference`,
  GET_TRANSACTIONS_BY_INVOICE: `/api/Payment/GetTransactionsByInvoiceID`,
  GET_PAYMENT_HISTORY: `/api/Payment/GetPaymentHistory`,
  GET_COMPANY_PAYMENT_HISTORY: `/api/Payment/GetCompanyPaymentHistory`,
  GET_ALL_TRANSACTIONS: `/api/Payment/GetAllTransactions`,
  POST_PROCESS_PAYMENT: `/api/Payment/ProcessPayment`,
  PATCH_UPDATE_TRANSACTION_STATUS: `/api/Payment/UpdateTransactionStatus`,
  POST_REFUND_TRANSACTION: `/api/Payment/RefundTransaction`,

  // Subscription Addons
  GET_ALL_ADDONS: `/api/Addon/GetAllAddons`,
  GET_ALL_ADDONS_WITH_PRICES: `/api/Addon/GetAllAddonsWithPrices`,
  GET_ADDON_BY_ID: `/api/Addon/GetAddonByID`,
  GET_ADDON_WITH_PRICES: `/api/Addon/GetAddonWithPrices`,
  POST_ADD_ADDON: `/api/Addon/AddAddon`,
  PUT_UPDATE_ADDON: `/api/Addon/UpdateAddon`,
  DELETE_ADDON: `/api/Addon/DeleteAddon`,
  PATCH_UPDATE_ADDON_STATUS: `/api/Addon/UpdateAddonStatus`,
  GET_ADDON_PRICES: `/api/Addon/GetAddonPrices`,
  POST_ADD_ADDON_PRICE: `/api/Addon/AddAddonPrice`,
  PUT_UPDATE_ADDON_PRICE: `/api/Addon/UpdateAddonPrice`,
  DELETE_ADDON_PRICE: `/api/Addon/DeleteAddonPrice`,

  // Company Subscription Addons (Linking)
  GET_COMPANY_ACTIVE_ADDONS: `/api/Subscription/GetCompanyActiveAddons`,
  POST_ADD_ADDON_TO_SUBSCRIPTION: `/api/Subscription/AddAddonToSubscription`,
  DELETE_REMOVE_ADDON_FROM_SUBSCRIPTION: `/api/Subscription/RemoveAddonFromSubscription`,
  PATCH_UPDATE_SUBSCRIPTION_ADDON_QUANTITY: `/api/Subscription/UpdateAddonQuantity`,

  // Quotes
  GET_ALL_QUOTES: `/api/Quote/GetAllQuotes`,
  GET_ACTIVE_QUOTES: `/api/Quote/GetActiveQuotes`,
  GET_QUOTE_BY_ID: `/api/Quote/GetQuoteByID`,
  POST_ADD_QUOTE: `/api/Quote/AddQuote`,
  PUT_UPDATE_QUOTE: `/api/Quote/UpdateQuote`,
  DELETE_QUOTE: `/api/Quote/DeleteQuote`,
  PATCH_UPDATE_QUOTE_STATUS: `/api/Quote/UpdateQuoteStatus`,
  POST_UPDATE_QUOTE_SORT_ORDER: `/api/Quote/UpdateQuoteSortOrder`

}

export default APIs;
